import { render } from "./Easy.vue?vue&type=template&id=2ed129a8&scoped=true"
import script from "./Easy.vue?vue&type=script&lang=js"
export * from "./Easy.vue?vue&type=script&lang=js"

import "./Easy.vue?vue&type=style&index=0&id=2ed129a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed129a8"]])

export default __exports__